import { observer } from 'mobx-react-lite';
import { Globe } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { LOCALE_LABELS, type LocaleCode } from '@/i18n/messages';
import { TOKEN_LocaleStore } from './LocaleStore';
import { useT } from './useT';

export const LocaleSwitcherView = observer(function LocaleSwitcherView() {
  const store = useResolve(TOKEN_LocaleStore);
  const t = useT();
  return (
    <label
      className="flex h-8 items-center gap-1 border border-steel-300 bg-white px-2 text-xs text-steel-700 hover:border-amber-signal hover:text-amber-signal dark:border-steel-700 dark:bg-steel-900 dark:text-steel-300"
      title={t.locale.chooseLanguage}
    >
      <Globe size={14} />
      <select
        aria-label={t.locale.chooseLanguage}
        value={store.current}
        onChange={(e) => void store.setLocale(e.target.value as LocaleCode)}
        className="bg-transparent font-mono uppercase outline-none"
      >
        {store.available.map((code) => (
          <option key={code} value={code} className="font-sans text-steel-900 dark:text-steel-100">
            {code.toUpperCase()} · {LOCALE_LABELS[code]}
          </option>
        ))}
      </select>
    </label>
  );
});
